export const HomePageExplore = [
    {
        tag: 'Free',
        courses: [
            {
                heading : "Learn HTML",
                description: "This course covers the basic concepts of HTML including creating and structuring , by using elements and tags, you can add text, images, videos, forms, and more. Learning HTML basics is an important first step in your web development journey and an essential skill for front- and back-end developers." , 
                level: 'Beginner',
                lessionNumber: 6 ,
            } ,
            {
                heading : "Learn CSS",
                description: "This course explores advanced topics in HTML5 and CSS3, including the design, layout and variations in display for different devices and screen sizes.", 
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading : "Responsive Web design",
                description: "This course teaches responsive web design techniques, Responsive web design is the practice of designing flexible websites that can respond to different screen sizes, orientations, and resolutions. In this course, you'll learn how to use CSS to make your webpages look good, no matter what device they're viewed on." , 
                level: 'Beginner',
                LessionNumber : 6
            } 
        ]
    } , 
    {
        tag: 'New to Coding',
        courses: [
            {
                heading : "Learn Python",
                description: "This course covers the basic concepts of HTML including creating and structuring , by using elements and tags, you can add text, images, videos, forms, and more. Learning HTML basics is an important first step in your web development journey and an essential skill for front- and back-end developers." , 
                level: 'Beginner',
                lessionNumber: 6 ,
            } ,
            {
                heading : "Learn React",
                description: "This course explores advanced topics in HTML5 and CSS3, including the design, layout and variations in display for different devices and screen sizes.", 
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading : "Learn Nodejs",
                description: "This course teaches responsive web design techniques, Responsive web design is the practice of designing flexible websites that can respond to different screen sizes, orientations, and resolutions. In this course, you'll learn how to use CSS to make your webpages look good, no matter what device they're viewed on." , 
                level: 'Beginner',
                LessionNumber : 6
            } 
        ]
    } ,
    {
        tag: 'Most Popular',
        courses: [
            {
                heading : "Learn ML",
                description: "This course covers the basic concepts of HTML including creating and structuring , by using elements and tags, you can add text, images, videos, forms, and more. Learning HTML basics is an important first step in your web development journey and an essential skill for front- and back-end developers." , 
                level: 'Beginner',
                lessionNumber: 6 ,
            } ,
            {
                heading : "Learn AI",
                description: "This course explores advanced topics in HTML5 and CSS3, including the design, layout and variations in display for different devices and screen sizes.", 
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading : "Learn Blockchain",
                description: "This course teaches responsive web design techniques, Responsive web design is the practice of designing flexible websites that can respond to different screen sizes, orientations, and resolutions. In this course, you'll learn how to use CSS to make your webpages look good, no matter what device they're viewed on." , 
                level: 'Beginner',
                LessionNumber : 6
            } 
        ]
    } ,
    {
        tag: 'Skill Paths',
        courses: [
            {
                heading : "Learn AI",
                description: "This course covers the basic concepts of HTML including creating and structuring , by using elements and tags, you can add text, images, videos, forms, and more. Learning HTML basics is an important first step in your web development journey and an essential skill for front- and back-end developers." , 
                level: 'Beginner',
                lessionNumber: 6 ,
            } ,
            {
                heading : "Learn CSS",
                description: "This course explores advanced topics in HTML5 and CSS3, including the design, layout and variations in display for different devices and screen sizes.", 
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading : "Responsive Web design",
                description: "This course teaches responsive web design techniques, Responsive web design is the practice of designing flexible websites that can respond to different screen sizes, orientations, and resolutions. In this course, you'll learn how to use CSS to make your webpages look good, no matter what device they're viewed on." , 
                level: 'Beginner',
                LessionNumber : 6
            } 
        ]
    } ,
    {
        tag: 'Career Paths',
        courses: [
            {
                heading : "Learn Nodejs",
                description: "This course covers the basic concepts of HTML including creating and structuring , by using elements and tags, you can add text, images, videos, forms, and more. Learning HTML basics is an important first step in your web development journey and an essential skill for front- and back-end developers." , 
                level: 'Beginner',
                lessionNumber: 6 ,
            } ,
            {
                heading : "Learn HTML",
                description: "This course explores advanced topics in HTML5 and CSS3, including the design, layout and variations in display for different devices and screen sizes.", 
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading : "Learn AI",
                description: "This course teaches responsive web design techniques, Responsive web design is the practice of designing flexible websites that can respond to different screen sizes, orientations, and resolutions. In this course, you'll learn how to use CSS to make your webpages look good, no matter what device they're viewed on." , 
                level: 'Beginner',
                LessionNumber : 6
            } 
        ]
    }
]
